module.exports = __webpack_public_path__ + "img/1-230109142523919.0d6cc80d.png";